import { Component, ElementRef, Input, OnDestroy, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CreateGroupPopupComponent, User } from '../create-group-popup/create-group-popup.component';
import { VideoSDK } from '@videosdk.live/js-sdk';
import { GroupSharingService } from '../group-sharing.service.component';
import { SpotlightService } from 'src/app/core/services/spotlight.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatBottomSheet, MatBottomSheetConfig } from '@angular/material/bottom-sheet';
import { EMPTY, Observable, Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, startWith, switchMap, takeUntil } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { CommonDialogComponent } from '../common-dialog/common-dialog.component';
import { HotToastService } from '@ngneat/hot-toast';
import { timer } from 'rxjs';
import * as moment from 'moment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AdminService } from 'src/app/core/services/admin-apis/admin.service';

@Component({
    selector: 'app-group-sharing-lobby',
    templateUrl: './group-sharing-lobby.component.html',
    styleUrls: ['./group-sharing-lobby.component.scss']
})
export class GroupSharingLobbyComponent implements OnInit, OnDestroy {
    meetingId: any;
    meeting: any;
    name: any;
    token: any;
    localParticipantAudio: any;
    eventId: string = '';
    joinEventDetails
    meetingStarted: boolean = false;
    customRoomId
    hostUserCustomId
    hostUserId
    eventDetails
    hostUser
    eventsList: any = [];
    userDetails: any = [];
    @ViewChild('videoContainer', { static: false }) videoContainer: ElementRef | undefined;
    users: Array<any> = Array(3).fill(1).map((n, i) => n + i); // based on array size will change
    micEnable: boolean = true;
    webCamEnable: boolean = true;
    cineJoySpotLightSchedule: any;
    isLoading: boolean = true;
    videocam_on = "assets/icons/group-sharing/videocam.svg"
    videocam_off = "assets/icons/group-sharing/videocam_off.svg"
    mic_on = "assets/icons/group-sharing/mic.svg"
    mic_off = "assets/icons/group-sharing/mic_off.svg"
    menu_icon = "assets/icons/group-sharing/more_vert.svg"
    totalParticipant: any = 0;
    filteredOptions: Observable<User[]>;
    myControl = new FormControl();
    first_video
    second_video
    isSlowMotionGraphicsLoading: boolean = false;
    cinejoyPremierDetails
    eventInterval: any;
    join_btn: boolean = false;
    panelOpenState = false;
    webcams: any = [];
    requestedForEntry: boolean = false;
    subscribeTimer: any;
    activateCounter: boolean = false;
    motionGraphicVideo: any;
    selectedUsers: any;
    groupshareUrl: string;
    @Input() premierDetails: any;
    canUserAccessMovie: boolean = false;
    message:any;
    timeLeft: any = 180;
    interval: any;
    premierInterval: any;
    @ViewChild('participantList') participantListTemplate: TemplateRef<any>;
    bottomsheetModel: any;
    subscriptions:any[];
    private processedMessages = new Set();
    private socketSubscription: Subscription;
    private destroy$ = new Subject<void>();

    constructor(public dialog: MatDialog,
        public gsService: GroupSharingService,
        public spotlightService: SpotlightService,
        private router: Router,
        private _snackBar: MatSnackBar,
        public bottomSheet: MatBottomSheet,
        private toast: HotToastService, private route: ActivatedRoute,
        private adminService:AdminService
    ) {
        this.eventId = this.route.snapshot.params.id;
    }

    ngOnInit(): void {
        this.gsService.getActiveComponent()
      .pipe(takeUntil(this.destroy$))
      .subscribe(activeComponent => {
        if (activeComponent !== 'GroupSharingLobbyComponent') {
          console.log('Component1 is inactive, stopping its actions');
          this.destroy$.next();
          this.destroy$.complete();
        }
      });
        this.getUserDetails();
        this.getActiveSubscription();
        //this.eventInterval= setInterval(()=>{
        this.getActiveParties()
        //  }, 5000)
        this.getStreamingLink()
        this.getPremierInfo()
        setTimeout(() => {
            this.isLoading = false;
        }, 3000)
        this.filteredOptions = this.myControl.valueChanges.pipe(
            startWith(''),
            debounceTime(400),
            distinctUntilChanged(),
            switchMap(val => {
                return this.filter(val || '')
            })
        )
        this.gsService.subscribeToEventWatchParty(this.eventId)

        if(localStorage.getItem('gslobby') !== 'end'){
            this.gsService.socketObservable.subscribe((res) => {

                if (res && res != undefined && Object.keys(res).length != 0) {
                    this.getActiveParties()
                    this.openSnackBarForParticipantAdded(res)
                }
            })
    
            this.gsService.joinFromInvite$.subscribe((res) => {
                if (res && res != undefined) {
                    this.eventId = res.eventId;
                    this.meetingId = this.eventsList.find((v) => v.eventId == res.eventId).roomId
                    this.getParticipantToken(res)
                }
            })
        }
       
        this.groupshareUrl = `/cinejoy/group-share-info-page`
    }

    openDialog() {

        this.dialog.open(CreateGroupPopupComponent, {
            width: '35vw',
            height: '100%',
            panelClass: 'create-group-dialog',
            data: {
                eventId: this.eventId,
                isPreScheduleEvent: false,
                subscriptions:this.subscriptions
            },
        }).afterClosed().subscribe((res) => {

            if (res) {
                this.meetingStarted = res.startMeeting;
                //  this.isGroupShareActive.emit('true');
                this.token = res.token;
                this.meetingId = res.meetingId;
                this.customRoomId = res.customRoomId
                this.getEventDetails()
                localStorage.setItem('meetingDetails', JSON.stringify(res))
                this.startMeeting(this.token, this.meetingId)
            }

        })
    }

    joinExsistingGroup() {
        if (this.canUserAccessMovie) {
            if (document.getElementById('startGrpBtn')) {
                document.getElementById('startGrpBtn').setAttribute('disabled', 'true')
                setTimeout(() => {
                    document.getElementById('startGrpBtn').setAttribute('disabled', 'false')
                }, 4000)
            }

            navigator.mediaDevices.getUserMedia({ video: true, audio: true }).then((stream) => {
                this.getHostToken()
            }).catch((err) => {
                console.error(`you got an error: ${err}`)
                this.openSnackBar('Please allow Camera and Microphone to start the group sharing on spotlight.', '')
            });
        } else {
            this.toast.show(`${this.message}`, {
                theme: 'snackbar',
                position: 'top-right',
                duration: 5000
            })
        }
    }

    openSnackBar(message: string, action: string) {
        this._snackBar.open(message, action, {
            duration: 5000,
            horizontalPosition: 'end',
            verticalPosition: 'top'
        });
    }

    getHostToken() {
        this.gsService.getHostToken(this.eventDetails.eventId, this.eventDetails.customRoomId).subscribe((res) => {
            res.startMeeting = true;
            res.entryRequested = false;
            res.meetingId = this.eventDetails.roomId,
                res.eventId = this.eventDetails.eventId,
                res.customRoomId = this.eventDetails.customRoomId,
                this.customRoomId = this.eventDetails.customRoomId
            this.token = res.token
            this.meetingId = this.eventDetails.roomId
            this.eventId = this.eventDetails.eventId
            res.isMeetingJoined = true
            this.meetingStarted = res.startMeeting;
            res.isAdmin = true;
            this.getEventDetails()
            localStorage.setItem('meetingDetails', JSON.stringify(res))
            this.startMeeting(res.token, this.eventDetails.roomId)
        }, err => {

        })
    }

    async startMeeting(token: any, meetingId: any) {
        // Meeting config
        console.log(token, meetingId)
        VideoSDK.config(token);

        this.meetingId = meetingId

        this.meeting = VideoSDK.initMeeting({
            meetingId: meetingId, // required
            name: (this.userDetails.firstName + ' ' + this.userDetails.lastName).toUpperCase(), // required
            micEnabled: true, // optional, default: true
            webcamEnabled: true, // optional, default: true
            maxResolution: "hd", // optional, default: "hd"
            //  token: token,
            participantId: this.userDetails.userId + '-sss'
        });
        this.meeting.join();
        this.setMeetingEvents();
        setTimeout(() => {
            this.createLocalParticipant(this.meeting)
        })

        this.webcams = await this.meeting?.getWebcams();
        const { deviceId, label } = this.webcams[0]

        this.meeting?.changeWebcam(deviceId);


    }

    createLocalParticipant(meeting: any) {

        //   this.participantId = meeting.localParticipant.id;
        const localParticipant = this.createVideoElement(meeting.localParticipant);

        this.videoContainer?.nativeElement.appendChild(localParticipant);
    }

    createVideoElement(participant: any) {

        let division;
        let mainDiv;
        mainDiv = document.createElement("div")
        mainDiv.setAttribute('id', `video-frame-${participant.id}`)
        division = document.createElement("div");
        division.setAttribute("id", `video-frame-container`);
        division.className = 'profile five-items-row'
        let videoElement = document.createElement("video");
        // videoElement.style.transform = "scale(-1,1)"
        videoElement.classList.add("video-frame");
        videoElement.setAttribute("id", `v-${participant.id}`);
        videoElement.setAttribute("playsinline", 'true');

        let optionsSpan = document.createElement('span')
        optionsSpan.className = 'vid-options-mute-icon'
        // optionsSpan.addEventListener('click', (e) => { this.toggleMic(e, participant) })
        // optionsSpan.innerHTML = ` <mat-icon id=iconaudiov-${participant.id} role="img" class="mat-icon notranslate material-symbols-outlined material-icons mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font" style="cursor:pointer;color:red;font-size: 18px">${participant?.micOn ? 'mic' : 'mic_off'}</mat-icon>`
        if (this.hostUser) {
            optionsSpan.addEventListener('click', (e) => { this.toggleMic(e) })
            optionsSpan.innerHTML = ` <mat-icon id=iconaudiov-${participant.id} role="img" class="mat-icon notranslate material-symbols-outlined material-icons mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font" style="cursor:pointer;color:red;font-size: 18px">${participant?.micOn ? 'mic' : 'mic_off'}</mat-icon>`
        } else if (this.meeting.localParticipant.id === participant.id) {
            optionsSpan.addEventListener('click', (e) => { this.toggleMic(e) })
            optionsSpan.innerHTML = ` <mat-icon id=iconaudiov-${participant.id} role="img" class="mat-icon notranslate material-symbols-outlined material-icons mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font" style="cursor:pointer;color:red;font-size: 18px">${participant?.micOn ? 'mic' : 'mic_off'}</mat-icon>`
        } else {
            optionsSpan.innerHTML = ` <mat-icon id=iconaudiov-${participant.id} role="img" class="mat-icon notranslate material-symbols-outlined material-icons mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font" style="color:red;font-size: 18px;cursor: default;">${participant?.micOn ? 'mic' : 'mic_off'}</mat-icon>`
        }
        let optionsVideoSpan = document.createElement('span')
        //  optionsVideoSpan.addEventListener('click', (e) => { this.toggleWebCam(e) })
        optionsVideoSpan.className = 'vid-options-video-icon'
        if (this.hostUser) {
            optionsVideoSpan.addEventListener('click', (e) => { this.toggleWebCam(e) })
            optionsVideoSpan.innerHTML = `<mat-icon  id=iconvideov-${participant.id} role="img" class="mat-icon notranslate material-symbols-outlined material-icons mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font" style="cursor:pointer;color:red;font-size: 18px">${participant?.webcamOn ? 'videocam' : 'videocam_off'}</mat-icon>`
        } else if (this.meeting.localParticipant.id === participant.id) {
            optionsVideoSpan.addEventListener('click', (e) => { this.toggleWebCam(e) })
            optionsVideoSpan.innerHTML = `<mat-icon  id=iconvideov-${participant.id} role="img" class="mat-icon notranslate material-symbols-outlined material-icons mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font" style="cursor:pointer;color:red;font-size: 18px">${participant?.webcamOn ? 'videocam' : 'videocam_off'}</mat-icon>`
        } else {
            optionsVideoSpan.innerHTML = `<mat-icon  id=iconvideov-${participant.id} role="img" class="mat-icon notranslate material-symbols-outlined material-icons mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font" style="color:red;font-size: 18px;cursor: default;">${participant?.webcamOn ? 'videocam' : 'videocam_off'}</mat-icon>`
        }
        let nameSpan = document.createElement("span");
        nameSpan.className = 'user-span-lobby';
        nameSpan.innerHTML = `${participant.displayName}`;
        division.appendChild(videoElement);
        division.appendChild(nameSpan)
        division.appendChild(optionsSpan)
        division.appendChild(optionsVideoSpan)
        mainDiv.appendChild(division)
        return mainDiv;

    }

    setTrack(stream: any, audioElement: any, participant: any, isLocal: any) {
        if (stream.kind == "video") {
            if (isLocal) {
                ////  videoCamOff.style.display = "none";
                //  videoCamOn.style.display = "inline-block";
            }

            const mediaStream = new MediaStream();
            mediaStream.addTrack(stream.track);

            let videoElm: any = document.getElementById(`v-${participant.id}`);

            if (videoElm) {

                videoElm.srcObject = mediaStream;
                videoElm
                    .play()
                    .catch((error: any) =>
                        console.error("videoElem.current.play() failed", error)
                    );
                participant.setViewPort(videoElm.offsetWidth, videoElm.offsetHeight);
            }

        }
        if (stream.kind == "audio") {
            if (isLocal) {
                // micOff.style.display = "none";
                // micOn.style.display = "inline-block";
                return
            }
            const mediaStream = new MediaStream();
            mediaStream.addTrack(stream.track);
            audioElement.srcObject = mediaStream;
            audioElement
                .play()
                .catch();
        }

    }

    setMeetingEvents() {
        this.meeting.localParticipant.on("stream-enabled", (stream: any) => {
            if (stream.kind === "video") {
                this.setTrack(
                    stream,
                    this.localParticipantAudio,
                    this.meeting.localParticipant,
                    true
                );
                let toggleIcon = document.getElementById(`iconvideov-${this.meeting.localParticipant.id}`);
                toggleIcon.innerHTML = 'videocam';
                this.webCamEnable = true
            }
            if (stream.kind == "audio") {
                let toggleIcon = document.getElementById(`iconaudiov-${this.meeting.localParticipant.id}`);
                toggleIcon.innerHTML = 'mic';
                this.micEnable = true;
            }
        });

        this.meeting.localParticipant.on("stream-disabled", (stream: any) => {
            if (stream.kind === "video") {
                let toggleIcon = document.getElementById(`iconvideov-${this.meeting.localParticipant.id}`);
                toggleIcon.innerHTML = 'videocam_off';
                this.webCamEnable = false;
            }
            if (stream.kind == "audio") {
                let toggleIcon = document.getElementById(`iconaudiov-${this.meeting.localParticipant.id}`);
                toggleIcon.innerHTML = 'mic_off';
                this.micEnable = false;
            }
        });

        this.meeting.on("participant-joined", (participant) => {
            let audioElement;
            let videoElement = this.createVideoElement(participant);
            this.totalParticipant++;

            if (this.meeting.localParticipant.id !== participant.id) {
                audioElement = this.createAudioElement(participant.id);
                audioElement.style['display'] = 'none'

                audioElement.setAttribute("autoplay", "true");
                audioElement.setAttribute("playsinline", "true");
            }

            participant.on("stream-enabled", (stream) => {

                if (stream.kind === "video") {
                    let toggleIcon = document.getElementById(`iconvideov-${participant.id}`);
                    if(toggleIcon){
                    toggleIcon.innerHTML = 'videocam';
                    }
                    else{
                        console.log("cannot found",participant.id,"in toggle icon video")
                        toggleIcon.innerHTML = 'videocam_off';

                    }
                }
                if (stream.kind == "audio") {
                    let toggleIcon = document.getElementById(`iconaudiov-${participant.id}`);


                    if(toggleIcon){
                        toggleIcon.innerHTML = 'mic';
                        }
                        else{
                            console.log("cannot found",participant.id,"in toggle icon mic")
                            toggleIcon.innerHTML = 'mic_off';
                        }
                }
                this.setTrack(stream, audioElement, participant, false);
            });
            participant.on("stream-disabled", (stream) => {
                if (stream.kind === "video") {
                    let toggleIcon = document.getElementById(`iconvideov-${participant.id}`);
                    if(toggleIcon){
                        toggleIcon.innerHTML = 'videocam_off';
                        }
                        else{
                            console.log("cannot found",participant.id,"in toggle icon video stream disable")
                            toggleIcon.innerHTML = 'videocam_off';
    
                        }
                }
                if (stream.kind == "audio") {
                    let toggleIcon = document.getElementById(`iconaudiov-${participant.id}`);
                    if(toggleIcon){
                        toggleIcon.innerHTML = 'mic_off';
                        }
                        else{
                            console.log("cannot found",participant.id,"in toggle icon mic stream disable")
                            toggleIcon.innerHTML = 'mic_off';
                        }
                }
            });
            this.videoContainer.nativeElement.appendChild(videoElement);
            this.videoContainer.nativeElement.appendChild(audioElement);
        });

        this.meeting.on("entry-requested", (data) => {
            const { participantId, name, allow, deny } = data;
            //allow()

            //
            const toastRef = this.toast.show(CommonDialogComponent, {
                data: {
                    fact: `${data.name} is requesting to join do you wish them to be part of this group?`,
                    joinScreen: true
                },
                autoClose: false,
                theme: 'snackbar',
                position: 'top-right'
            });
            toastRef.afterClosed.subscribe((e) => {

                if (e.dismissedByAction) {
                    // callback function to accept the request
                    allow();
                } else {

                    // callback function to reject the request
                    deny();
                }
            });
        });

        this.meeting.on("webcam-requested", ({ accept, reject }) => {
            const toastRef = this.toast.show(CommonDialogComponent, {
                data: {
                    fact: 'Host is requesting for Web-cam',
                    joinScreen: false
                },
                style: {
                    width: '300px'
                },
                autoClose: true,
                theme: 'snackbar',
                position: 'top-right',
                duration: 5000
            });
            toastRef.afterClosed.subscribe((e) => {

                if (e.dismissedByAction) {

                    // callback function to accept the request
                    accept();

                } else {

                    // callback function to reject the request
                    reject();
                }
            });
        });

        this.meeting.on("mic-requested", ({ accept, reject }) => {
            const toastRef = this.toast.show(CommonDialogComponent, {
                data: {
                    fact: 'Host is requesting you to unmute',
                    joinScreen: false
                },
                style: {
                    width: '300px'
                },
                autoClose: true,
                theme: 'snackbar',
                position: 'top-right',
                duration: 5000,

            });
            toastRef.afterClosed.subscribe((e) => {

                if (e.dismissedByAction) {
                    // callback function to accept the request
                    accept();
                } else {
                    // callback function to reject the request
                    reject();
                }
            });
        });

        this.meeting.on("participant-left", (participant) => {

            this.totalParticipant--;
            this.requestedForEntry = false;
            this.toast.show(`${participant.displayName} has left the meeting`, {
                theme: 'snackbar',
                position: 'top-right'
            })
            let vElement = document.getElementById(`v-${participant.id}`);
            let wholeElement = document.getElementById(`video-frame-${participant.id}`);

            // wholeElement.remove()
            vElement.remove();

            let aElement = document.getElementById(`a-${participant.id}`);

            aElement.parentNode.removeChild(aElement);


            //remove it from participant list participantId;
            document.getElementById(`p-${participant.id}`).remove();
        });

        this.meeting.on("entry-responded", (participantId, decision) => {
            if (this.meeting?.localParticipant?.id === participantId) {
                if (decision === "allowed") {
                    // entry allowed
                    this.meetingStarted = true;
                } else {
                    // entry denied
                    this.leaveMeeting(true);
                    this.toast.show(`Admin has denied you to be part of this group`, {
                        theme: 'snackbar',
                        position: 'top-right'
                    })
                    this.join_btn = false;
                    //   this.openSnackBar('Admin has denied you to be part of this group', '')
                }
            }

        });

        this.meeting.on("meeting-left", () => {
            this.meetingStarted = false;
            this.requestedForEntry = false;
            this.totalParticipant--
            this.toast.close()
            this.dialog.closeAll()
            this.bottomSheet.dismiss()
        });

        this.meeting.on("meeting-joined", () => {
            this.totalParticipant++;
        });
    }

    createAudioElement(pId: any) {
        if (pId == this.meeting.localParticipant.id) {
            return null;
        }
        let audioElement = document.createElement("audio");
        audioElement.setAttribute("autoPlay", "false");
        audioElement.setAttribute("playsInline", "true");
        audioElement.setAttribute("controls", "false");
        audioElement.setAttribute('muted', 'true')
        audioElement.setAttribute("id", `a-${pId}`);
        return audioElement;
    }

    userJoinMeeting(event) {

        this.token = event.token;
        this.meetingId = event.roomId;
        this.eventId = event.eventId;
        this.joinEventDetails = event;
        this.meetingStarted = true;
        this.customRoomId = event.customRoomId
        // this.isGroupShareActive.emit(event)
        this.startMeeting(this.token, this.meetingId)
        this.toast.show(`Requested Host to let you in!`, {
            theme: 'snackbar',
            position: 'top-right',
            duration: 5000
        })
        this.getEventDetails()
    }

    getEventDetails() {
        // this.eventDetails=[]
        this.gsService.getActiveWatchParty(this.eventId).subscribe((res) => {
            let item;
            // this.eventDetails = res;

            let userDetails = JSON.parse(localStorage.getItem('userData'))
            if (res) {
                item = res.find((v) => v.customRoomId == this.customRoomId)
            }
            this.eventDetails = item;
            this.hostUserId = item.userId
            this.hostUserCustomId = item.userId + '-sss'
            this.selectedUsers = this.eventDetails.participants;
            if (userDetails.userId === item.userId) {

                this.hostUser = true;
            } else {
                this.hostUser = false;
            }
        }, err => {

        })
    }

    joinGroupEvent(item) {
        this.toast.close()
        if (this.canUserAccessMovie) {
            if (!this.requestedForEntry) {
                this.requestedForEntry = true;
                navigator.mediaDevices.getUserMedia({ video: true, audio: true }).then((stream) => {
                    this.meetingId = item.roomId;
                    this.getParticipantToken(item);
                }).catch((err) => {

                });
            } else {
                this.toast.show(`Please Wait untill host lets you in!`, {
                    theme: 'snackbar',
                    position: 'top-right',
                    duration: 5000
                })
            }
        } else {
            this.toast.show(`${this.message}`, {
                theme: 'snackbar',
                position: 'top-right',
                duration: 5000
            })
        }
    }

    getParticipantToken(item) {
        this.gsService.getParticipantToken(this.eventId, item.customRoomId).subscribe((res) => {
            const obj = { token: res.token, roomId: this.meetingId, eventId: this.eventId, customRoomId: item.customRoomId, isAdmin: false }
            localStorage.setItem('meetingDetails', JSON.stringify(obj))
            this.userJoinMeeting({ token: res.token, roomId: this.meetingId, eventId: this.eventId, customRoomId: item.customRoomId })
        }, err => {

        })
    }
    exsistingGroup: boolean = false;
    getActiveParties() {
        this.eventsList = []

        this.gsService.getActiveWatchParty(this.eventId).subscribe((res) => {

            let item: any = '';
            if (localStorage.getItem('userData')) {
                item = JSON.parse(localStorage.getItem('userData'))
            }
            // res.forEach(element => {
            //     if (element.participants.find((v) => v.userId === item.userId && v.status !== 'DELETED')) {
            //         this.eventsList.push(element)
            //     }
            // });
            this.eventsList = res.filter((element, index, self) =>
                element.participants.some((v) => v.userId === item.userId && v.status !== 'DELETED') &&
                index === self.findIndex((e) => e.id === element.id) // Ensure uniqueness by checking id
              );
            if (res.filter((v) => v.userId == item.userId).length > 0) {
                this.eventDetails = res.filter((v) => v.userId == item.userId)[0];
                this.exsistingGroup = true;
            } else {
                this.exsistingGroup = false;
            }
        }, err => {

        })
    }

    getUserDetails() {
        this.spotlightService.getUserDetails().toPromise().then((res: any) => {
            this.userDetails = res;
            res['userId'] = res.userID ? res.userID : res.userId
            localStorage.setItem('userData', JSON.stringify(res));
        }).catch((err: any) => {

        });
    }

    async toggleMic(event?: Event, item?: any) {
        let toggleIcon2: any = document.getElementById('listLocalAudio');
        let elementId: string = (event?.target as Element).id;
        if (elementId === 'listLocalAudio' || elementId.split('-')[1] == this.meeting.localParticipant.id.split('-')[0]) {
            if (this.micEnable) {
                let toggleIcon = document.getElementById(`iconaudiov-${this.meeting.localParticipant.id}`);
                toggleIcon.innerHTML = 'mic_off';
                if (toggleIcon2 != null) {
                    toggleIcon2.src = this.mic_off
                }
                this.micEnable = false;
                this.meeting?.muteMic();
            } else {
                let toggleIcon = document.getElementById(`iconaudiov-${this.meeting.localParticipant.id}`);
                toggleIcon.innerHTML = 'mic';
                this.micEnable = true;
                if (toggleIcon2 != null) {
                    toggleIcon2.src = this.mic_on;
                }
                let customAudioTrack = await VideoSDK.createMicrophoneAudioTrack({
                    encoderConfig: "high_quality",
                    noiseConfig: {
                        noiseSuppression: true,
                        echoCancellation: true,
                        autoGainControl: true,
                    },
                    microphoneId: ''
                });
                this.meeting?.unmuteMic(customAudioTrack);
            }
        } else {
            const participants = this.meeting.participants;
            let participant;
            if (participants.get(elementId.replace('iconaudiov-', ''))) {
                participant = participants.get(elementId.replace('iconaudiov-', ''));
            } else {
                participant = participants.get(elementId.replace('listmic-', ''));
            }
            let toggleIcon = document.getElementById(`iconaudiov-${participant.id}`);

            if (participant?.micOn) {
                participant.disableMic();
            } else {
                participant.enableMic();
            }
        }

    }

    async toggleWebCam(event?: Event) {
        let toggleIcon1: any = document.getElementById('listLocalVideo');
        let elementId: string = (event?.target as Element).id;
        if (elementId === 'listLocalVideo' || elementId.split('-')[1] == this.meeting.localParticipant.id.split('-')[0]) {
            let toggleIcon = document.getElementById(`iconvideov-${this.meeting.localParticipant.id}`);
            if (this.webCamEnable) {
                this.webCamEnable = false;
                toggleIcon.innerHTML = 'videocam_off';
                if (toggleIcon1 != null) {
                    toggleIcon1.src = this.videocam_off
                }
                this.meeting?.disableWebcam();
            } else {
                this.webCamEnable = true;
                toggleIcon.innerHTML = 'videocam';
                if (toggleIcon1 != null) {
                    toggleIcon1.src = this.videocam_on
                }
                this.meeting?.enableWebcam();
            }
        } else {
            const participants = this.meeting.participants;

            let participant;
            if (participants.get(elementId.replace('iconvideov-', ''))) {
                participant = participants.get(elementId.replace('iconvideov-', ''));

            } else {
                participant = participants.get(elementId.replace('listvideo-', ''));
            }
            let toggleIcon = document.getElementById(`iconvideov-${participant.id}`);
            if (participant?.webcamOn) {
                //   toggleIcon.innerHTML = 'videocam_off';
                participant.disableWebcam();
            } else {
                // toggleIcon.innerHTML = 'videocam';
                participant.enableWebcam();
            }
        }
    }

    getPremierInfo() {
       this.spotlightService.cmsGetPremierdeatails(this.eventId)
       .toPromise().then((responseData: any) => {

            this.cinejoyPremierDetails = responseData
            this.cineJoySpotLightSchedule = responseData.cinejoySpotlightsSchedule;
            const groupSharingSchedule = this.cineJoySpotLightSchedule.find((x: any) => x.scheduleMainText === 'GS1')
            const redCarpetSchedule = this.cineJoySpotLightSchedule.filter((x: any) => x.scheduleMainText === 'Red Carpet');
            const redCarpetURL = 'cinejoy/spotlight-root/' + responseData.eventId + '/' + responseData.name.replaceAll(' ', '-');
            this.first_video = responseData.motionGraphic[0].firstVideo;
            this.second_video = responseData.motionGraphic[0].secondVideo;
            let endOfFestival = this.cineJoySpotLightSchedule.find(s => s.scheduleMainText === 'End of Festivities').scheduleTimeText;
            let endOfFestivalAdd10 = endOfFestival + 36000000;
            this.motionGraphicVideo = localStorage.getItem("motionGraphics" + this.eventId);
            if (this.motionGraphicVideo === 'done') {
                this.isSlowMotionGraphicsLoading = false;
                this.isLoading = true;
                setInterval(() => {
                    this.isLoading = false
                }, 4000)
            } else if (this.motionGraphicVideo == null) {
                this.isSlowMotionGraphicsLoading = true;
                this.isLoading = false;
            }
            this.premierInterval = setInterval(() => {
                const currentTimeText = Date.now()
                const currentTimeText1 = new Date()
                const endTime = new Date(redCarpetSchedule[0].scheduleTimeText)
                if (moment(redCarpetSchedule[0].scheduleTimeText).subtract(3, 'minutes') <= moment(currentTimeText)) {
                    this.activateCounter = true;
                    let diff = endTime.getTime() - currentTimeText1.getTime()
                    var seconds = diff / 1000;
                    if (this.timeLeft > 0) {
                        this.timeLeft = seconds.toFixed(0)
                    } else {
                        this.timeLeft = 180;
                    }
                }
            }, 1000)
        }, err => {

        })
    }

    getRedCarpetIndex(): number {
        let i = 0;
        for (const schedule of this.cineJoySpotLightSchedule) {
            if (schedule.scheduleMainText === 'Red Carpet') {
                break;
            }
            i++;
        }
        return i;
    }

    durationVideoTime(graphicsT: boolean): void {
        this.isLoading = true;
        this.isSlowMotionGraphicsLoading = false;
        this.startRedCarpetpagecounter(graphicsT);
    }

    startRedCarpetpagecounter(graphicsT?: boolean): void {

        const interval = setInterval(() => {
            const currentTimeText = new Date().getTime();
            if (graphicsT === true) {
                this.isSlowMotionGraphicsLoading = false;
                setTimeout(() => {
                    this.isLoading = false;
                }, 5000);
            }
            //  const currentTimeText = Date.now();
            const groupSharingSchedule = this.cineJoySpotLightSchedule.find((x: any) => x.scheduleMainText === 'GS1')
            const redCarpetSchedule = this.cineJoySpotLightSchedule.filter((x: any) => x.scheduleMainText === 'Red Carpet');
            const redCarpetURL = 'cinejoy/spotlight-root/' + this.cinejoyPremierDetails.eventId + '/' + this.cinejoyPremierDetails.name.replaceAll(' ', '-');
            if ((redCarpetSchedule[0].scheduleTimeText <= currentTimeText) && (this.cineJoySpotLightSchedule[this.getRedCarpetIndex() + 1].scheduleTimeText >= currentTimeText)) {
                clearInterval(interval);
                if(this.bottomSheet){
                    this.bottomsheetModel.dismiss()
                }
                else{
                    console.log("no data found in bottom sheet modal,, navigating to redcarpet")
                }
                const data = localStorage.getItem('meetingDetails')
                if(data){
                    this.meeting.leave();
                }
                else{
                    console.log("no data found in local storage, navigating to redcarpet")
                }
                this.dialog.closeAll()
                this.router.navigate([redCarpetURL])
            }
        }, 3000);
    }

    leaveMeeting(value:boolean) {
        this.meeting?.disableWebcam()
        this.meeting?.muteMic()
        this.totalParticipant = 0;
        this.join_btn = false;
        this.meeting?.leave();
        this.getActiveParties()
        if (this.hostUser) {
            this.hostUser = false;
        }
        this.requestedForEntry = false;
        this.meetingStarted = false;
        if(value){
        localStorage.removeItem('meetingDetails')
        this.stopMediaTracks()
        }
    }

    closeBottomSheet() {
        this.bottomSheet.dismiss();
    }

    getDisplayName(item) {
        return item.value;
    }

    getControlValue(value: string, controlValue: any) {
        if (value === 'mic') {
            return `listmic-${controlValue.value.id}`
        } else {
            return `listvideo-${controlValue.value.id}`
        }
    }

    removeParticipant(item) {
        let participantId = item.key.replace('sss', "")
        this.bottomSheet.dismiss()
        this.meeting.participants.get(item.key).remove()
        this.requestedForEntry = false;
        let obj = {
            "partyType": "PRIVATE",
            "customRoomId": this.customRoomId,
            "eventId": this.eventId,
            "userIds": [
                participantId
            ]
        }
        this.gsService.removeParticipants(obj).subscribe((res) => {
            // this.bottomSheet.dismiss()
        }, err => {

        })
    }

    getIsUserHost(item) {
        if (item?.id === this.hostUserCustomId || item?.key === this.hostUserCustomId) {
            return true

        } else {
            return false
        }
    }

    addParticipantsToExsistingEvent(userId) {
        let item = JSON.parse(localStorage.getItem('userData'))
        if (this.selectedUsers.find((p) => p.userId == userId) || userId === this.hostUserId) {
            this.toast.show(`Participant has been already added in to this group.`, {
                theme: 'snackbar',
                position: 'top-right',
                duration: 5000
            })
            return null;
        }

        const obj = {
            "partyType": "PRIVATE",
            "customRoomId": this.customRoomId,
            "eventId": this.eventId,
            "userIds": [
                userId
            ]
        }
        this.gsService.addParticipantToExisitingEvent(obj).subscribe((res) => {
            this.filteredOptions = this.myControl.valueChanges.pipe(
                startWith(''),
                debounceTime(400),
                distinctUntilChanged(),
                switchMap(val => {
                    return this.filter(val || '')
                })
            )
        }, err => {
            this.filteredOptions = this.myControl.valueChanges.pipe(
                startWith(''),
                debounceTime(400),
                distinctUntilChanged(),
                switchMap(val => {
                    return this.filter(val || '')
                })
            )
        })
    }

    filter(val: string): Observable<any[]> {
        // call the service which makes the http-request
        if (val.length > 3) {
            return this.gsService.getPublicUsersList(val)
                .pipe(
                    map(response => response.filter(option => {
                        let item: any = ''
                        if (localStorage.getItem('userData')) {
                            item = JSON.parse(localStorage.getItem('userData'))
                        }
                        return (option.userId != item.userID && !this.eventDetails.participants.find((p) => p.userId == option.userId))
                    }))
                )
        }
        return EMPTY;

    }

    openParticipantTemplate(config?: MatBottomSheetConfig) {
        //config.panelClass = 'cus-participant-template'

        this.bottomsheetModel = this.bottomSheet.open(this.participantListTemplate, config)

        this.bottomsheetModel.afterOpened().subscribe((res) => {

            let toggleIcon1: any = document.getElementById('listLocalVideo');
            let toggleIcon2: any = document.getElementById('listLocalAudio');
            if (this.webCamEnable) {
                if (toggleIcon1) {
                    toggleIcon1.src = this.videocam_on;
                }
            } else {
                if (toggleIcon1) {
                    toggleIcon1.src = this.videocam_off;
                }
            }
            if (this.micEnable) {
                if (toggleIcon1) {
                    toggleIcon2.src = this.mic_on;
                }
            } else {
                if (toggleIcon1) {
                    toggleIcon2.src = this.mic_off;
                }
            }

        })
        return this.bottomsheetModel;
    }

    openSnackBarForParticipantAdded(message) {

        if (this.processedMessages.has(message.roomId)) {
            return; 
          }
          this.processedMessages.add(message.roomId+message.userId);
      
        const toastRef = this.toast.show(CommonDialogComponent, {
            data: {
                fact: `You have been invited to ${message.description} by  ${message.hostFirstName}`,
                joinScreen: false
            },
            theme: 'snackbar',
            position: 'top-right',
            id:`notify-${message.roomId}-${message.userId}`,
            duration: 25000,
            persist:{ enabled: true, count: 1 }

        });
        setTimeout(() => this.processedMessages.delete(message.roomId+message.userId), 22000);

        setTimeout(() => {
            toastRef.close();
          }, 24000);
        toastRef.afterClosed.subscribe((e) => {
            if (e.dismissedByAction) {
                // callback function to accept the request
                // this.gsService.joinFromInvite$.next({ eventId: message.eventId, customRoomId: message.customRoomId })
                this.joinGroupEvent(message)
            } else {
                // callback function to reject the request
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        if (this.socketSubscription) {
            this.socketSubscription.unsubscribe();
          }
          localStorage.setItem('gslobby','end')
        this.processedMessages.clear();
        this.meeting?.leave();
        this.meeting?.disableWebcam()
        this.meeting?.muteMic()
        this.leaveMeeting(false)
        this.bottomSheet.dismiss()
        this.dialog.closeAll()
    }

    changeWebcam(id: any) {
        const { deviceId, label } = this.webcams.filter((v) => v.deviceId === id);
        this.meeting?.changeWebcam(deviceId);
    }

    getStreamingLink(): void {
        this.spotlightService.getAgilitixStreamingLink(this.eventId,'SPOTLIGHT').subscribe((response) => {
            if (response.Error !== undefined) {
                this.canUserAccessMovie = false;
                this.message = 'You do not have access to the movie. Please Purshace tickets to be part of any group';
            } else if (response.AccessStatus === 'AccessValid') {
                this.canUserAccessMovie = true;
            } else if (response.AccessStatus === 'BeforeEvent') {
                this.canUserAccessMovie = false;
                this.message = 'Movie Viewing to occur 24-31 March 2025';
            } else if (response.AccessStatus === 'AccessExpired') {
                this.canUserAccessMovie = false;
                this.message = 'Your access to this movie is expired. Please purchase the movie again.';
            }
        }, (error: any) => {
            this.canUserAccessMovie = false;
            this.message = 'You do not have access to the movie. Please Purshace tickets to be part of any group';
        });
    }

    getActiveSubscription(){
        this.adminService.getActiveSubscription().subscribe(
            {
              next:(data:any[])=>{
                        this.subscriptions=data;
                        
                      },
              error:(error)=>{
                      console.log("error while fetching subscription", error);
              }
            }
          );
    }
    stopMediaTracks() {
        navigator.mediaDevices.getUserMedia({ video: true, audio: true })
          .then(stream => {
            stream.getTracks().forEach(track => {
              track.stop(); 
              stream.removeTrack(track); 
            });
      
            navigator.mediaDevices.getUserMedia({ video: false, audio: false })
              .catch(error => console.error("Error stopping media devices:", error));
          })
          .catch(error => console.error("Error accessing media devices:", error));
      }
}
